import { Container, Row, Col, Button, Card } from "react-bootstrap"
import { useTranslation } from "react-i18next"
import { useNavigate } from "react-router-dom"
import { XCircle, QrCode } from "lucide-react"

const InvalidQRPage = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const handleScanAgain = () => {
    navigate("/scanner")
  }

  return (
    <Container className="py-4" style={{ maxWidth: "600px" }}>
      <Row className="mb-4">
        <Col>
          <Card className="shadow-sm text-center py-5">
            <Card.Body>
              <div className="mb-4">
                <div
                  className="mx-auto d-flex align-items-center justify-content-center rounded-circle bg-danger bg-opacity-10"
                  style={{ width: "100px", height: "100px" }}
                >
                  <XCircle size={50} className="text-danger" />
                </div>
              </div>

              <h2 className="h3 mb-3 text-danger">{t("scanner.errors.invalidQR")}</h2>
              <p className="text-muted mb-4">
                {t("scanner.errors.invalidQRMessage")}
              </p>

              <div className="d-flex flex-column gap-3 align-items-center">
                <Button
                  variant="dark"
                  size="lg"
                  onClick={handleScanAgain}
                  className="d-flex align-items-center justify-content-center"
                  style={{ minWidth: "200px" }}
                >
                  <QrCode size={20} className="me-2" />
                  {t("scanner.scanAgain")}
                </Button>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  )
}

export default InvalidQRPage

